import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from "../../core/auth/auth.service";
import * as _ from 'lodash';

@Injectable()
export class AccessGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log('AccessGuard:canActivate:route', route);
    console.log('AccessGuard:canActivate:state', state);
    if ( this.hasAccessRole()) {
      return true;
    } else {
      this.router.navigate(['/login']);
    }
    return false;
  }

  private hasAccessRole() {
    return _.indexOf(this.authService.decodedJwtToken.authorities, "GLOTTO_ROOT") > -1
      || _.indexOf(this.authService.decodedJwtToken.authorities, "GLOTTO_ADMIN") > -1;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/common/access-guard.ts